<div *ngIf="numberLocations" fxLayout="column">
  <div fxLayout="row" fxLayoutGap="10px" class="mb-1">
    <flex-search-input class="full-width" [(ngModel)]="filterValue"></flex-search-input>
  </div>

  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" class="mb-1">
    <button mat-stroked-button color="accent" class="button-add" (click)="createNumberLocation()">
      <mat-icon class="icon-add">add</mat-icon>
      <span class="vertical-align">{{ 'number_location.action.create'|translate }}</span>
    </button>
  </div>

  <ng-container *ngFor="let item of numberLocationsFiltered">
    <mat-card (click)="selectNumberLocation(item)"
      class="shadow-none number-location-item" [ngClass]="{'selected': selectedItem?.id == item.id}">
      <mat-card-title fxLayout="row" fxLayoutAlign="start center">
        <div class="number-location-name">{{ item.name }}</div>
        <div fxFlex fxLayoutAlign="end center">
          <mat-icon *ngIf="!isSelected(item); else tplDefaultNumberLocation"
            class="icon-arrow">expand_more</mat-icon>
          <ng-template #tplDefaultNumberLocation>
            <button data-ci="select" type="button" mat-flat-button mat-button-sm color="accent"
              class="icon-arrow" (click)="selectNumberLocation(item); applySelect()">
              {{ 'public.select_item'|translate }}
            </button>
          </ng-template>
        </div>
      </mat-card-title>
      <mat-card-content *ngIf="isSelected(item)">
        <div class="number-location-address">{{ item.address }}</div>
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>
